const BASE_URL = process.env.REACT_APP_API_ENDPOINT
const BASE_PATH = '/api/v1/guideline/'

export default {
  getGuidelineData: `${BASE_URL}${BASE_PATH}guideline-list/`
}
